export function Resources(): JSX.Element {
    return (
        <div>
            Work in progress
        </div>
    )
}
